/** @internal */
export const MessageId = 'app.network.status';
